// extracted by mini-css-extract-plugin
export default {"container":"WidthInput_container__-GAJT"};